import Chart from "chart.js";
const Style = require("@vg-faset/core/styles/export-js.scss");

Chart.defaults.global.defaultFontFamily = Style.fontDefault;
Chart.defaults.global.defaultFontColor = Style.colorAlmostBlack;
Chart.defaults.global.defaultFontSize = 12;
Chart.defaults.global.elements.point.radius = 0;
Chart.defaults.global.elements.point.hoverRadius = 7;
Chart.defaults.global.elements.point.hoverBorderWidth = 2;
Chart.defaults.global.elements.line.tension = 0.01;
Chart.defaults.global.elements.line.borderCapStyle = "round";
Chart.defaults.global.elements.line.borderJoinStyle = "round";
Chart.defaults.global.elements.line.fill = false;

export default Chart;
